module.exports = __webpack_public_path__ + "assets/img/logo2.2d763df0.png";